export default () => {
    return {
        urlCopied: false,
        show: false,
        init() {
            console.log("Social share model");
        },

        toggleModal(state) {
            const el = document.getElementById('social-share-modal');
            if (state === 'show') {
                el.classList.remove('hidden');
                el.classList.add('flex');
            }
            else {
                el.classList.add('hidden');
                el.classList.remove('flex');
            }

        },
        shareOnTwitter(url, title) {
            window.open(
                "http://twitter.com/share?url=" +
                encodeURIComponent(url) +
                "&text=" +
                encodeURIComponent(title),
                "",
                "left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
            );
        },
        shareOnFacebook(url, title) {
            window.open(
                "http://facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url),
                title,
                "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
            );
        },
        copyLink() {
            const shareUrl = document.getElementById("social-share-url");

            /* Select the text field */
            shareUrl.select();
            shareUrl.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            navigator.clipboard.writeText(shareUrl.value);
            this.urlCopied = true;
        },
    }
}